import { render, staticRenderFns } from "./form-wrapper.vue?vue&type=template&id=555f3a2c"
import script from "./form-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./form-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports